import { getPermissions } from './'

export const fetchPermissions = async () => {
  const req = await getPermissions()
  return {
    type: 'GET_PERMISSIONS_SUCCESS',
    data: req.permissions
  }
}
